<template>
  <div>
    <CountHeader header="รายละเอียดการนับสต๊อก" :img_header="header_image" link_back="count_stock/historylist"/>
    <Count_Details/>
  </div>
</template>

<script>
import HeaderImage from '@/assets/checklist.png'
import CountHeader from "@/components/admin/count_stock/headercount_stock/CountHeader.vue";
import Count_Details from "@/components/admin/count_stock/Count_Details.vue";
export default {
  name: "CountDetails",
  components: {
    Count_Details,
    CountHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
